import { render, staticRenderFns } from "./VehicleViewGlobal.vue?vue&type=template&id=795f80a9"
import script from "./VehicleViewGlobal.vue?vue&type=script&lang=js"
export * from "./VehicleViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports